import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconRewrite2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconRewrite2"><Path d="M11.5 5L7.5 1.75V4H2V20H10V18H4V6H7.5V8.25L11.5 5Z" fill="currentColor"/><Path d="M12.5 19L16.5 15.75V18H20V11H22V20H16.5V22.25L12.5 19Z" fill="currentColor"/><Path d="M19 2L16.9571 4.04289L19.9571 7.04289L22 5L19 2Z" fill="currentColor"/><Path d="M9 12L15.5429 5.45711L18.5429 8.45711L12 15H9V12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconRewrite2;
